module.exports = __webpack_public_path__ + "assets/img/c28302f3077d3120475197c1085aa72e.png";